// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__3Zcyy","inner":"Form_inner__2psZG","range":"Form_range__24Eit","name":"Form_name__39jeG","actions":"Form_actions__3cw1i"};